// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","Collection":"_192RvH","filterLoading":"_141DZP","containsSuperHero":"_15vxNC","fadeInFrames":"_27bEfk"};